import { render, staticRenderFns } from "./zprili.vue?vue&type=template&id=6b00a7cd&scoped=true&"
import script from "./zprili.vue?vue&type=script&lang=js&"
export * from "./zprili.vue?vue&type=script&lang=js&"
import style0 from "./zprili.vue?vue&type=style&index=0&id=6b00a7cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b00a7cd",
  null
  
)

export default component.exports